import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="checkbox-selection"
export default class extends Controller {
  static targets = ["selectAll", "checkbox"]

  declare selectAllTarget: HTMLInputElement
  declare checkboxTargets: HTMLInputElement[]
  declare hasSelectAllTarget: boolean

  connect(): void {
    this.updateSelectAllState()
  }

  toggleAll(event: Event): void {
    const checked = (event.target as HTMLInputElement).checked
    this.checkboxTargets.forEach((checkbox) => {
      checkbox.checked = checked
    })
  }

  toggle(): void {
    this.updateSelectAllState()
  }

  updateSelectAllState(): void {
    if (!this.hasSelectAllTarget) return

    const allChecked = this.checkboxTargets.length > 0 &&
                       this.checkboxTargets.every((checkbox) => checkbox.checked)
    const someChecked = this.checkboxTargets.some((checkbox) => checkbox.checked)

    this.selectAllTarget.checked = allChecked
    this.selectAllTarget.indeterminate = someChecked && !allChecked
  }
}
